import { render, staticRenderFns } from "./vue-core-video-player.vue?vue&type=template&id=58e681de&"
import script from "./vue-core-video-player.vue?vue&type=script&lang=js&"
export * from "./vue-core-video-player.vue?vue&type=script&lang=js&"
import style0 from "./vue-core-video-player.vue?vue&type=style&index=0&land=less&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports